import { render, staticRenderFns } from "./DodCustomersList.vue?vue&type=template&id=6283e776&scoped=true&"
import script from "./DodCustomersList.vue?vue&type=script&lang=js&"
export * from "./DodCustomersList.vue?vue&type=script&lang=js&"
import style0 from "./DodCustomersList.vue?vue&type=style&index=0&id=6283e776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6283e776",
  null
  
)

export default component.exports